/**
 * Interações gerais do tema: menu mobile, pesquisa, popup de newsletter,
 * acordeões, seletor de variantes e o painel de seleção de tamanho.
 * O carrinho (drawer) vive à parte em cart.js.
 */
(function () {
  "use strict";

  document.documentElement.classList.remove("no-js");

  /* ---------------- Menu mobile ---------------- */
  (function mobileNav() {
    var toggle = document.getElementById("menuToggle");
    var nav = document.getElementById("MobileNav");
    var backdrop = document.getElementById("MobileNavBackdrop");
    var closeBtn = document.getElementById("mobileNavClose");
    if (!toggle || !nav || !backdrop) return;

    function open() {
      nav.classList.add("is-open");
      backdrop.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
    }
    function close() {
      nav.classList.remove("is-open");
      backdrop.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
    }
    toggle.addEventListener("click", open);
    backdrop.addEventListener("click", close);
    if (closeBtn) closeBtn.addEventListener("click", close);
    nav.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", close); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
  })();

  /* ---------------- Pesquisa ---------------- */
  (function search() {
    var toggle = document.getElementById("searchToggle");
    var panel = document.getElementById("HeaderSearch");
    if (!toggle || !panel) return;
    toggle.addEventListener("click", function () {
      var isOpen = !panel.hidden;
      panel.hidden = isOpen;
      toggle.setAttribute("aria-expanded", String(!isOpen));
      if (!isOpen) {
        var input = panel.querySelector("input[type=search]");
        if (input) input.focus();
      }
    });
  })();

  /* ---------------- Popup de newsletter ---------------- */
  (function popup() {
    var popupEl = document.getElementById("NewsletterPopup");
    if (!popupEl) return;
    var closeBtn = document.getElementById("popupClose");
    var skipBtn = document.getElementById("popupSkip");
    var delay = parseInt(popupEl.getAttribute("data-popup-delay"), 10) || 1500;
    var storageKey = "urveia_popup_dismissed";

    function show() {
      popupEl.classList.add("is-open");
    }
    function hide() {
      popupEl.classList.remove("is-open");
      try { sessionStorage.setItem(storageKey, "1"); } catch (e) {}
    }

    var dismissed = false;
    try { dismissed = sessionStorage.getItem(storageKey) === "1"; } catch (e) {}

    var formPostedSuccessfully = popupEl.querySelector("[data-form-success]");
    if (!dismissed || formPostedSuccessfully) {
      setTimeout(show, delay);
    }
    if (closeBtn) closeBtn.addEventListener("click", hide);
    if (skipBtn) skipBtn.addEventListener("click", hide);
    popupEl.addEventListener("click", function (e) {
      if (e.target === popupEl) hide();
    });
  })();

  /* ---------------- Acordeões (descrição, FAQ, etc.) ---------------- */
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest("[data-acc-trigger]");
    if (!trigger) return;
    var item = trigger.closest(".acc-item, .md-acc-item");
    var panel = item.querySelector(".acc-panel, .md-acc-panel");
    var open = item.classList.toggle("open");
    panel.style.maxHeight = open ? panel.scrollHeight + "px" : "0px";
  });

  /* ---------------- Seletor de variantes ---------------- */
  document.querySelectorAll("product-page").forEach(function (root) {
    var sectionId = root.getAttribute("data-section-id");
    var dataEl = document.getElementById("ProductJson-" + sectionId);
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);

    var optionCount = product.options ? product.options.length : (product.variants[0].options || []).length;
    var selected = new Array(optionCount).fill(null);
    var sizeTouched = false; // exige seleção explícita de tamanho antes de comprar

    var variantIdInput = document.getElementById("ProductVariantId-" + sectionId);
    var priceBlock = document.getElementById("PriceBlock-" + sectionId);
    var form = root.querySelector("[data-product-form]");
    var sizeGrid = root.querySelector("[data-size-grid]");
    var sizeWarning = root.querySelector("[data-size-warning]");
    var selectedColorLabel = root.querySelector("[data-selected-color]");

    // Inicializa `selected` a partir da variante pré-selecionada pelo servidor,
    // exceto a opção de tamanho, que fica por escolher até o cliente clicar.
    var initialVariant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    var sizeOptionIndex = sizeGrid ? parseInt(sizeGrid.getAttribute("data-option-index"), 10) : null;
    var colorSwatchesEl = root.querySelector("[data-color-swatches]");
    var colorOptionIndex = colorSwatchesEl ? parseInt(colorSwatchesEl.getAttribute("data-option-index"), 10) : null;
    initialVariant.options.forEach(function (val, i) {
      if (i !== sizeOptionIndex) selected[i] = val;
    });

    function findVariant() {
      return product.variants.find(function (v) {
        return v.options.every(function (val, i) { return selected[i] === null || selected[i] === val; });
      });
    }

    function money(cents) {
      return (cents / 100).toLocaleString("fi-FI", { style: "currency", currency: "EUR" });
    }

    function render() {
      var variant = findVariant();

      root.querySelectorAll("[data-option-value]").forEach(function (btn) {
        var idx = parseInt(btn.getAttribute("data-option-index"), 10);
        btn.classList.toggle("active", selected[idx] === btn.getAttribute("data-value"));
      });

      if (selectedColorLabel && colorOptionIndex !== null && selected[colorOptionIndex]) {
        selectedColorLabel.textContent = selected[colorOptionIndex];
      }

      var atcButtons = root.querySelectorAll("[data-add-to-cart], [data-add-to-cart-trigger]");

      if (!variant) {
        atcButtons.forEach(function (btn) { btn.disabled = true; btn.textContent = "Yhdistelmä ei saatavilla"; });
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceBlock) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        var oldEl = priceBlock.querySelector("[data-price-compare]");
        var nowEl = priceBlock.querySelector("[data-price]");
        if (nowEl) nowEl.textContent = money(variant.price);
        if (oldEl) {
          oldEl.hidden = !onSale;
          if (onSale) oldEl.textContent = money(variant.compare_at_price);
        }
      }

      atcButtons.forEach(function (btn) {
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? "Lisää ostoskoriin" : "Loppuunmyyty";
      });
    }

    function requiresSizeAndMissing() {
      return sizeOptionIndex !== null && !sizeTouched;
    }
    function warnMissingSize() {
      if (sizeWarning) sizeWarning.hidden = false;
      if (sizeGrid) {
        sizeGrid.classList.remove("shake");
        void sizeGrid.offsetWidth;
        sizeGrid.classList.add("shake");
        sizeGrid.scrollIntoView({ block: "center", behavior: "smooth" });
      }
    }

    root.addEventListener("click", function (e) {
      if (e.target.closest("[data-add-to-cart-trigger]")) {
        // Botão fixo no mobile: submete o formulário real do produto (mesma validação de tamanho).
        if (requiresSizeAndMissing()) { warnMissingSize(); return; }
        if (form && form.requestSubmit) form.requestSubmit();
        return;
      }
      var btn = e.target.closest("[data-option-value]");
      if (!btn) return;
      var idx = parseInt(btn.getAttribute("data-option-index"), 10);
      var value = btn.getAttribute("data-value");
      if (btn.disabled) return;
      selected[idx] = value;
      if (idx === sizeOptionIndex) {
        sizeTouched = true;
        if (sizeWarning) sizeWarning.hidden = true;
      }
      render();
    });

    if (form) {
      form.addEventListener("submit", function (e) {
        if (requiresSizeAndMissing()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          warnMissingSize();
        }
      });
    }

    render();
  });

  /* ---------------- Galeria de produto (carrossel horizontal) ---------------- */
  document.querySelectorAll("[id^='ShotCarousel-']").forEach(function (carousel) {
    var wrap = carousel.closest(".shot-carousel-wrap");
    if (!wrap) return;
    var prev = wrap.querySelector("[data-shot-prev]");
    var next = wrap.querySelector("[data-shot-next]");
    var dots = wrap.querySelectorAll("[data-shot-dots] .shot-dot");
    var slides = carousel.querySelectorAll(".shot-slide");

    function slideWidth() {
      return carousel.clientWidth;
    }
    function goTo(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      carousel.scrollTo({ left: index * slideWidth(), behavior: "smooth" });
    }
    function currentIndex() {
      return Math.round(carousel.scrollLeft / slideWidth());
    }
    if (prev) prev.addEventListener("click", function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener("click", function () { goTo(currentIndex() + 1); });

    var ticking = false;
    carousel.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var idx = currentIndex();
        dots.forEach(function (d, i) { d.classList.toggle("active", i === idx); });
        ticking = false;
      });
    });
  });

  /* ---------------- Recomendações de produtos ---------------- */
  document.querySelectorAll("[data-product-recommendations]").forEach(function (el) {
    var url = el.getAttribute("data-url");
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("[data-product-recommendations]");
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });
})();
